module.exports = __webpack_public_path__ + "static/media/radiology.51f9a346.svg";